import { render } from "./YellowCategoryModal.vue?vue&type=template&id=6143cc6d"
import script from "./YellowCategoryModal.vue?vue&type=script&lang=js"
export * from "./YellowCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__